<template>
  <div class="table-mode-head" v-loading="loading">
    <div class="tip">
      <span>字段管理</span>
      <!-- <span class="btnHover btn" :class="{'disabled': isReset}" @click="reset">重置</span> -->
    </div>
    <div class="table-head-key" id="table-head">
      <vuedraggable element="div" class="scroll-inner-wrap" v-bind="dragOptions()" handle=".drag" :list="dataset" @end="onListEnd">
        <div class="list-item" v-for="(item, index) in dataset" :key="index" :data-id="item.id" :data-show="item.is_show">
          <span name="head-handle" class="head-handle">
            <i class="icon iconfont iconicon_drag_order tableIconHover drag"></i>
            <a>{{ item.component_name_in_template }}</a>
          </span>
          <el-switch v-model="item.is_show" size="mini" @change="radioChange(index)"></el-switch>
        </div>
      </vuedraggable>
    </div>
    <div class="footer">
      <span class="text-blue" @click="addKey"><i class="icon iconfont iconicon_new_subproject"></i>添加和管理字段</span>
    </div>
  </div>
</template>
<script>
import apiKey from "@/services/api/customKey/customKey";
import bus from "@/bus";
import vuedraggable from "vuedraggable";
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
export default {
  props: {
    projectId: {
      type: [Number, String],
      default: "",
    },
    task_id: {
      type: [Number, String, Object, Array],
    },
    show: Boolean,
  },
  components: {
    vuedraggable,
  },
  data() {
    return {
      dataset: [],
      loading: false,
    };
  },
  mounted() {},
  watch: {
    show() {
      if (this.show) {
        this.getTableList();
      }
    },
  },
  computed: {
    isReset() {
      return this.dataset.some(res => res.is_show) || !this.dataset || this.dataset.length === 0
    }
  },
  methods: {
    ...mapActions("customKey/customKey", ["getprojectTemplate", "changeHeadTemplate"]),
    addKey() {
      this.$router.push({
        path: '/customKeyPage',
        query: {
          project_id: this.projectId
        }
      });
    },
    async getTableList() {
      this.loading = true;
      let params = {
        number: 999,
        page: 1,
        project_id: this.projectId,
      };
      let result =  await this.getprojectTemplate(params)
      this.dataset = JSON.parse(JSON.stringify(result && result.length ?
      result.filter(res => res.id).map((res) => {
        this.$set(res, 'is_show', Boolean(res.is_show) )
        return res;
      })
      : []))
      this.loading = false;
    },
    radioChange(idx) {
      // this.dataset[idx].is_show = !this.dataset[idx].is_show;
      let temp = this.dataset.map((res) => {
        return {
          component_id_in_template: res.id,
          sort: res.sort,
          is_show: Number(res.is_show),
        };
      });
      let params = {
        template_id: this.dataset[idx].template_id,
        standard_components: temp,
      };
      apiKey.updateTemplateStandardComponentOtherContent(params).then(async (res) => {
        await this.changeHeadTemplate({ number: 999, page: 1, project_id: this.projectId });
        this.$emit("changeHead");
      });
    },
    onListEnd(e) {
      let eles = e.target.getElementsByClassName("list-item");
      let length = eles.length;
      let temp = [];
      for (let i = 0; i < length; i++) {
        temp.push({
          component_id_in_template: eles[i].dataset.id,
          sort: i,
          is_show: Number(eles[i].dataset.show),
        });
      }
      let params = {
        template_id: this.dataset[0].template_id,
        standard_components: temp,
      };
      apiKey.updateTemplateStandardComponentOtherContent(params).then(async (res) => {
        await this.changeHeadTemplate({ number: 999, page: 1, project_id: this.projectId });
        this.$emit("changeHead");
      });
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
      };
    },
    reset() {
      if(this.isReset) return
      this.dataset.map(res => {
        res.is_show = true
      })
      let temp = this.dataset.map((res) => {
        return {
          component_id_in_template: res.id,
          sort: res.sort,
          is_show: Number(res.is_show),
        };
      });
      let params = {
        template_id: this.dataset[0].template_id,
        standard_components: temp,
      };
      apiKey.updateTemplateStandardComponentOtherContent(params).then(async (res) => {
        await this.changeHeadTemplate({ number: 999, page: 1, project_id: this.projectId });
        this.$emit("changeHead");
      });
    },
    hideBox() {
      this.$emit("hide", this.task_id);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/mixin.scss";
.table-mode-head {
  max-height: 100vh;
  overflow-x: hidden;
  width: 278px;
  .head-handle {
    display: flex;
    width: 100%;
    align-items: center;
    i {
      flex-shrink: 0;
    }
    a {
      width: 0;
      flex: 1;
      @include ellipsis();
    }
  }
  .scroll-inner-wrap {
    flex-direction: column;
    width: 100%;
    .el-checkbox__inner::after {
      left: 0 !important;
      top: 1px !important;
    }
  }
  .key-button {
    margin: 16px 11px;
  }
  .tip {
    font-size: 12px;
    height: 64px;
    line-height: 40px;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    .icon {
      &:hover {
        cursor: pointer;
      }
    }
    span {
      font-size: 16px;
      font-weight: 500;
    }
    .btn {
      font-size: 14px;
      color: rgba(32, 32, 32, 0.6);
      padding: 4px 6px;
      display: flex;
      align-items: center;
      line-height: 1;
    }
  }
  .table-head-key {
    font-size: 12px;
    max-height: 72vh;
    overflow-x: hidden;
  }
  .list-item {
    display: flex;
    justify-content: space-between;
    padding-left: 20px;
    padding-right: 28px;
    align-items: center;
    cursor: pointer;
    position: relative;
    height: 40px;
    z-index: 9;
    span {
      font-size: 14px;
      i {
        color: rgba(32, 32, 32, 0.4);
        font-size: 14px;
        display: flex;
        align-items: center;
        line-height: 1;
        margin-right: 8px;
      }
    }
  }
  .blue-background-class {
    border: 2px dashed #2682ff;
  }
  .footer {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: rgba(32, 32, 32, 0.8);
    border-top: 1px solid rgba(32, 32, 32, 0.08);
    margin-top: 8px;
    span {
      padding: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        font-size: 14px;
        margin-right: 9px;
      }
    }
  }
}
</style>
